import React from 'react';
import { ProjectsListing } from '@components/projectsListing/projectsListing';
import { apiUrls } from '@constants/apiurls';
import projects from '@redux/modules/projects';
import styles from '@components/dashboard/dashboard.module.scss';
import { routesPath } from '@constants/routesPath';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { ClientHeader } from '@components/clientHeader/clientHeader';
import clients from '@redux/modules/clients';
import { Spinner } from '@components/loader/loader';
import { useState, useEffect } from 'react';
import { fetchAutoCompleteData } from '@services/autoCompleteService';

export const ProjectsListingContainer = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [colors, setColors] = useState([]);

  useEffect(() => {
    const getColors = async () => {
      const colrs = await fetchAutoCompleteData('', apiUrls.getColors());
      setColors(colrs);
    };
    getColors();
  }, []);

  const {
    data: clientData,
    error: clientError,
    isFetching: clientLoading,
  } = clients.list().useClientsdetailQuery(
    { params: { id: params.clientId }, extendedPath: apiUrls.getClientDetail() },
    {
      skip: !params.clientId,
    },
  );
  
  const onAdd = () => {
    navigate(routesPath.addProjects(params.clientId));
  };
  
  const onProjectEdit = (project) => {
    navigate(routesPath.updateProject(params.clientId, project.id));
  };
  
  return (
    <div className={styles.dashboardWrappper}>
      {clientLoading ? (
        <div className="text-center ">
          <Spinner height="100" width="100" />
        </div>
      ) : (
        <ProjectsListing
          clients={clientData?.data}
          projects={clientData?.data?.projects}
          colors={clientData?.data?.colors || colors}
          onProjectAdd={onAdd}
          onProjectEdit={onProjectEdit}
        />
      )}
    </div>
  );
};
